import { useState } from 'react';
import type { FormField } from '../../types';
import { FormFieldWrapper } from './FormFieldWrapper';

interface Props { field: FormField; value: unknown; onChange: (v: unknown) => void; error?: string; }
export function AmountField({ field, value, onChange, error }: Props) {
  const presets = field.presetAmounts ?? [10, 25, 50, 100];
  const [custom, setCustom] = useState(!presets.includes(value as number) && value != null);
  return (
    <FormFieldWrapper field={field} error={error}>
      <div className="amount-presets">
        {presets.map(a => (
          <button key={a} type="button" className={`preset-btn ${value === a && !custom ? 'active' : ''}`}
            onClick={() => { setCustom(false); onChange(a); }}>£{a}</button>
        ))}
        <button type="button" className={`preset-btn ${custom ? 'active' : ''}`}
          onClick={() => { setCustom(true); onChange(''); }}>Other</button>
      </div>
      {custom && <input type="number" min="0.01" step="0.01" value={typeof value === 'number' ? value : ''}
        onChange={e => { const n = parseFloat(e.target.value); onChange(Number.isNaN(n) ? '' : n); }}
        placeholder="Enter amount" />}
    </FormFieldWrapper>
  );
}
